import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* fetchJourneyDocuments(params) {
  try {
    const journeyDocuments = yield call(function() {
      return Api.get(`/journey/documents/${params.uuid}`)
    });
    yield put({type: 'FETCH.JOURNEY_DOCUMENTS.SUCCESS', journeyDocuments});
  } catch (error) {
    yield put({type: 'FETCH.JOURNEY_DOCUMENTS.FAILURE', error});
  }
}

function* saveJourneyDocuments(params) {
  try {
    const journeyDocuments = yield call(function() {
      return Api.post(`/journey/documents`, params.body)
    });
    yield put({type: 'SAVE.JOURNEY_DOCUMENTS.SUCCESS', journeyDocuments});
    yield put({type: 'SHOW_NOTIFICATION', notification: {message:'save.success'}});
  } catch (error) {
    yield put({type: 'SAVE.JOURNEY_DOCUMENTS.FAILURE', error});
  }
}

function* deleteJourneyDocuments(params) {
  try {
    const journeyDocuments = yield call(function() {
      return Api.delete(`/journey/documents/${params.uuid}?key=${params.key}`)
    });
    yield put({type: 'DELETE.JOURNEY_DOCUMENTS.SUCCESS', journeyDocuments});
  } catch (error) {
    yield put({type: 'DELETE.JOURNEY_DOCUMENTS.FAILURE', error});
  }
}

export function* watchFetchJourneyDocuments() {
  yield takeEvery('FETCH.JOURNEY_DOCUMENTS.REQUEST', fetchJourneyDocuments)
}

export function* watchSaveJourneyDocuments() {
  yield takeEvery('SAVE.JOURNEY_DOCUMENTS.REQUEST', saveJourneyDocuments)
}

export function* watchDeleteJourneyDocuments() {
  yield takeEvery('DELETE.JOURNEY_DOCUMENTS.REQUEST', deleteJourneyDocuments)
}
